import { UpdateRegistrationDocument } from "@pathwright/graphql-client/src/generated"

export default UpdateRegistrationDocument
